export enum ReportBy {
  Default,
  City,
  ElectionPlace,
  LocalCommunity,
}
